import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";

import {TREND_RCN_COLOR, TREND_RP_COLOR} from "../../constants/trend_series_colors";

interface Props {
    /** Hides the RCN entry when the RCN line has no points for the current filters. */
    hasRcnData: boolean;
}

export const PricesTrendLegend = (props: Props) => {
    const {hasRcnData} = props;

    return (
        <div className={legendStyle}>
            <div className={itemStyle}>
                <span className={dotStyle} style={{backgroundColor: TREND_RP_COLOR}} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Ofertowa (RP), mies.
                </Text>
            </div>

            {hasRcnData && (
                <div className={itemStyle}>
                    <span className={dotStyle} style={{backgroundColor: TREND_RCN_COLOR}} />
                    <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                        Transakcyjna (RCN), mies.
                    </Text>

                    <DsTooltip
                        popover={<Message type="info">Ceny z aktów notarialnych (Rejestr Cen Nieruchomości), agregowane kwartalnie.</Message>}
                        type="info"
                        placement="top"
                    >
                        {({refs, getReferenceProps}) => (
                            <span ref={refs.setReference} className={infoTriggerStyle} {...getReferenceProps()}>
                                <InfoIcon size="1.6" fill="var(--colors-gray-600)" />
                            </span>
                        )}
                    </DsTooltip>
                </div>
            )}

            <span className={dividerStyle} />

            <div className={itemStyle}>
                <span className={dashIconStyle} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Dane wstępne
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={rangeIconStyle} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Możliwy zakres
                </Text>
            </div>
        </div>
    );
};

const legendStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3
});

const itemStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const dotStyle = css({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0
});

const infoTriggerStyle = css({
    display: "inline-flex",
    cursor: "pointer"
});

// body_copy_2's own line-height (20px on both breakpoints) doesn't match the Figma spec for the legend,
// which wants 18px on mobile - only that one property needs overriding, font-size/weight already match.
const legendTextStyle = css({
    lineHeight: "1.8rem",
    md: {lineHeight: "2rem"}
});

const dividerStyle = css({
    display: "none",
    md: {display: "block"},
    width: "1px",
    height: "18px",
    backgroundColor: "var(--colors-gray-400)",
    flexShrink: 0
});

// Matches the chart's dashed preliminary-zone boundary line (PricesTrendChart's xAxis.plotLines).
const dashIconStyle = css({
    width: "24px",
    borderTop: "2.5px dashed var(--colors-secondary)",
    flexShrink: 0
});

const rangeIconStyle = css({
    width: "24px",
    height: "12px",
    borderRadius: "3px",
    backgroundColor: "var(--colors-secondary)",
    opacity: 0.14,
    flexShrink: 0
});
import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";

import {TREND_RCN_COLOR, TREND_RP_COLOR} from "../../constants/trend_series_colors";

interface Props {
    /** Hides the RCN entry when the RCN line has no points for the current filters. */
    hasRcnData: boolean;
}

export const PricesTrendLegend = (props: Props) => {
    const {hasRcnData} = props;

    return (
        <div className={legendStyle}>
            <div className={itemStyle}>
                <span className={dotStyle} style={{backgroundColor: TREND_RP_COLOR}} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Ofertowa (RP), mies.
                </Text>
            </div>

            {hasRcnData && (
                <div className={itemStyle}>
                    <span className={dotStyle} style={{backgroundColor: TREND_RCN_COLOR}} />
                    <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                        Transakcyjna (RCN), mies.
                    </Text>

                    <DsTooltip
                        popover={<Message type="info">Ceny z aktów notarialnych (Rejestr Cen Nieruchomości), agregowane kwartalnie.</Message>}
                        type="info"
                        placement="top"
                    >
                        {({refs, getReferenceProps}) => (
                            <span ref={refs.setReference} className={infoTriggerStyle} {...getReferenceProps()}>
                                <InfoIcon size="1.6" fill="var(--colors-gray-600)" />
                            </span>
                        )}
                    </DsTooltip>
                </div>
            )}

            <span className={dividerStyle} />

            <div className={itemStyle}>
                <span className={dashIconStyle} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Dane wstępne
                </Text>
            </div>

            <div className={itemStyle}>
                <span className={rangeIconStyle} />
                <Text variant="body_copy_2" as="span" className={legendTextStyle} color="var(--colors-gray-700)">
                    Możliwy zakres
                </Text>
            </div>
        </div>
    );
};

const legendStyle = css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3
});

const itemStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1
});

const dotStyle = css({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0
});

const infoTriggerStyle = css({
    display: "inline-flex",
    cursor: "pointer"
});

// body_copy_2's own line-height (20px on both breakpoints) doesn't match the Figma spec for the legend,
// which wants 18px on mobile - only that one property needs overriding, font-size/weight already match.
const legendTextStyle = css({
    lineHeight: "1.8rem",
    md: {lineHeight: "2rem"}
});

const dividerStyle = css({
    display: "none",
    md: {display: "block"},
    width: "1px",
    height: "18px",
    backgroundColor: "var(--colors-gray-400)",
    flexShrink: 0
});

// Matches the chart's dashed preliminary-zone boundary line (PricesTrendChart's xAxis.plotLines).
const dashIconStyle = css({
    width: "24px",
    borderTop: "2.5px dashed var(--colors-secondary)",
    flexShrink: 0
});

const rangeIconStyle = css({
    width: "24px",
    height: "12px",
    borderRadius: "3px",
    backgroundColor: "var(--colors-secondary)",
    opacity: 0.14,
    flexShrink: 0
});
